import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Animation for Banner - text and button slide in on scroll
 */
export const animateBanner = (bannerRef, wordRef, buttonRef) => {
  if (bannerRef.current && wordRef.current && buttonRef.current) {
    // Set initial state immediately to prevent flash
    gsap.set(wordRef.current, { opacity: 0, x: -100 });
    gsap.set(buttonRef.current, { opacity: 0, x: 100 });
    
    const timer = setTimeout(() => {
      // Animate text from left on scroll
      gsap.to(wordRef.current, {
        opacity: 1,
        x: 0,
        duration: 0.8,
        delay: 0.2,
        ease: "power3.out",
        scrollTrigger: {
          trigger: bannerRef.current,
          start: "top 85%",
          toggleActions: "play none none none",
        },
      });

      // Animate button from right on scroll (starts after text begins)
      gsap.to(buttonRef.current, {
        opacity: 1,
        x: 0,
        duration: 0.8,
        delay: 0.4,
        ease: "power3.out",
        scrollTrigger: {
          trigger: bannerRef.current,
          start: "top 85%",
          toggleActions: "play none none none",
        },
      });
      
      ScrollTrigger.refresh();
    }, 100);
    
    return () => clearTimeout(timer);
  }
};

